import React from 'react';
import './Accordion.css'
import { useEffect, useState } from 'react';

const Accordion = ({ articleObj }) => {
    var content = articleObj;
    const defaultExpand = content.expanded || false;
    const [expanded, setExpanded] = useState(defaultExpand);
    useEffect(() => {
        setExpanded(defaultExpand)
    }, [defaultExpand])
    const handleToggle = () => {
        setExpanded(prev => !prev);
    }

    return (
        <>
            <div className={`${content.attributes.articleRendering} ${content.attributes.class} accordion-div`}>
                <div className="accordion accordion-div" id={"accordion" + content.contentId}>
                    <div className="accordion-item accordion-item-div">
                        <h2 className="accordion-header" id={"headingOne" + content.contentId}>
                            <button className={`accordion-button accordion-icon accordion-button-text ${expanded ? '' : 'collapsed'}`} onClick={handleToggle} aria-expanded={expanded} type="button" aria-controls={"collapseOne" + content.contentId}>
                                <p className="accordion-p" dangerouslySetInnerHTML={{ __html: content.title }} ></p>
                            </button>
                        </h2>
                        <div id={"collapseOne" + content.contentId} className={`accordion-collapse collapse ${expanded ? 'show' : ''}`} aria-labelledby={"headingOne" + content.contentId} data-bs-parent={"#accordion" + content.contentId}>
                            <div className="accordion-body accordion-body-content">
                                <p className="accordion-p" dangerouslySetInnerHTML={{ __html: content.body }} ></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )

}

export default Accordion

